module.exports = __webpack_public_path__ + "files/4279c183fb0c3db031fa6ba792b87bbe.png";